import Box from '@mui/material/Box';

import type { FieldKind } from '@/core/dcr/fields/types';
import { formatPhoneNumber } from '@/utils/formatters/formatPhoneNumber';

import { dcrFieldValueStyles as sx } from './DCRFieldValue.styles';

const CommaListValue = ({ value }: { value: string }) => (
	<Box sx={sx.multiLineValue}>
		{value
			.split(',')
			.map(part => part.trim())
			.filter(Boolean)
			.map((part, index) => (
				<Box key={`${index}-${part}`}>{part}</Box>
			))}
	</Box>
);

type Props = {
	value: string | null | undefined;
	kind?: FieldKind;
	country?: string | null;
};

export const DCRFieldValue = ({ value, kind, country }: Props) => {
	if (!value) return <>{value ?? ''}</>;

	if (kind === 'multiPicklist' && value.includes(',')) {
		return <CommaListValue value={value} />;
	}

	if (kind === 'phone') {
		return <>{formatPhoneNumber(value, country) || value}</>;
	}

	return <>{value}</>;
};
